// 为方便判断权限，最多只嵌套一层路由
export default [
  {
    path: '/teamChat',
    name: 'teamChat',
    meta: {
      keep_alive: false,
      module_id: 'teamChat',
    },
    component: () => import('@/views/chatroom/teamChat.vue'),
  },
  {
    path: '/seaspool',
    name: 'seaspool',
    meta: {
      module_id: 'seaspool',
    },
    component: () => import('@/views/seaspool/index.vue'),
  },
  {
    path: '/setting',
    name: 'setting',
    meta: {
      module_id: 'setting',
    },
    component: () => import('@/views/setting/index.vue'),
    children: [
      {
        path: '/setting/microSubjectManage',
        name: 'microSubjectManage',
        meta: {
          module_id: 'microSubjectManage',
        },
        component: () => import('@/views/setting/child/microSubjectManage.vue'),
      },
      {
        path: '/setting/serviceProviderManage',
        name: 'serviceProviderManage',
        meta: {
          module_id: 'serviceProviderManage',
        },
        component: () => import('@/views/setting/child/serviceProviderManage.vue'),
      },
      {
        path: '/setting/microBaoManage',
        name: 'microBaoManage',
        meta: {
          module_id: 'microBaoManage',
        },
        component: () => import('@/views/setting/child/microBaoManage.vue'),
      },
      {
        path: '/setting/yunZhenJiManage',
        name: 'yunZhenJiManage',
        meta: {
          module_id: 'yunZhenJiManage',
        },
        component: () => import('@/views/setting/child/yunZhenJiManage.vue'),
      },
      {
        path: '/setting/officalAccountManage',
        name: 'officalAccountManage',
        meta: {
          module_id: 'officalAccountManage',
        },
        component: () => import('@/views/setting/child/officalAccountManage.vue'),
      },
      {
        path: '/setting/riskControlConfig',
        name: 'riskControlConfig',
        meta: {
          module_id: 'riskControlConfig',
        },
        component: () => import('@/views/setting/child/riskControlConfig.vue'),
      },
      {
        path: '/setting/teamManage',
        name: 'teamManage',
        meta: {
          module_id: 'teamManage',
        },
        component: () => import('@/views/setting/child/teamManage.vue'),
      },
      {
        path: '/setting/teamConfigManage',
        name: 'teamConfigManage',
        meta: {
          module_id: 'teamConfigManage',
        },
        component: () => import('@/views/setting/child/teamConfigManage.vue'),
      },
      {
        path: '/setting/roleConfigManage',
        name: 'roleConfigManage',
        meta: {
          module_id: 'roleConfigManage',
        },
        component: () => import('@/views/setting/child/roleConfigManage.vue'),
      },
      {
        path: '/setting/permissionManage',
        name: 'permissionManage',
        meta: {
          module_id: 'permissionManage',
        },
        component: () => import('@/views/setting/child/permissionManage.vue'),
      },
    ],
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      module_id: 'contact',
    },
    component: () => import('@/views/customer/index.vue'),
    children: [
      {
        path: '/contact/thirdPartyContact',
        name: 'thirdPartyContact',
        meta: {
          module_id: 'thirdPartyContact',
        },
        component: () => import('@/views/customer/child/thirdPartyContact.vue'),
      },
      {
        path: '/contact/customer',
        name: 'customer',
        meta: {
          module_id: 'customer',
        },
        component: () => import('@/views/customer/child/customer.vue'),
      },
    ],
  },
  {
    path: '/robot',
    name: 'robot',
    meta: {
      module_id: 'robot',
    },
    component: () => import('@/views/robot/index.vue'),
    children: [
      {
        path: '/robot/conversation',
        name: 'robotConversation',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/robot/child/conversation.vue'),
      },
      {
        path: '/robot/robotLoginLog',
        name: 'robotLoginLog',
        meta: {
          module_id: 'robotLoginLog',
        },
        component: () => import('@/views/robot/child/robotLoginLog.vue'),
      },
      {
        path: '/robot/chatMark',
        name: 'robotChatMark',
        meta: {
          module_id: 'chat_mark',
        },
        component: () => import('@/views/conversation/index.vue'),
      },
      {
        path: '/robot/skillPlate',
        name: 'robotSkillPlate',
        meta: {
          module_id: 'robotSkillPlate',
        },
        component: () => import('@/views/robot/child/skillPlate.vue'),
      },
      {
        path: '/robot/skillDetail',
        name: 'robotSkillDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/robot/child/skillDetail.vue'),
      },
      {
        path: '/robot/skillFQAEdit',
        name: 'robotSkillFQAEdit',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/robot/child/skillFQAEdit.vue'),
      },
      {
        path: '/robot/problemIncluded',
        name: 'robotProblemIncluded',
        meta: {
          module_id: 'robotProblemIncluded',
        },
        component: () => import('@/views/robot/child/problemIncluded.vue'),
      },
    ],
  },
  {
    path: '/dataStatistics',
    name: 'dataStatistics',
    meta: {
      module_id: 'dataStatistics',
    },
    component: () => import('@/views/dataStatistics/index.vue'),
    children: [
      {
        path: '/dataStatistics/personalReception',
        name: 'personalReception',
        meta: {
          module_id: 'personalReception',
        },
        component: () => import('@/views/dataStatistics/child/personalReception.vue'),
      },
      {
        path: '/dataStatistics/summaryReception',
        name: 'summaryReception',
        meta: {
          module_id: 'summaryReception',
        },
        component: () => import('@/views/dataStatistics/child/summaryReception.vue'),
      },
    ],
  },

  {
    path: '/ticket',
    name: 'ticket',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/ticket/index.vue'),
    children: [
      {
        path: '/ticket/list',
        name: 'ticketList',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/ticketList.vue'),
      },
      {
        path: '/ticket/report',
        name: 'ticketReport',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/ticketReport.vue'),
      },
      {
        path: '/ticket/create',
        name: 'ticketCreate',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/ticketCreate.vue'),
      },
      {
        path: '/ticket/detail/:id',
        name: 'ticketDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/ticketDetail.vue'),
      },
      {
        path: '/ticket/knowledge',
        name: 'ticketKnowledge',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/ticketKnowledge.vue'),
      },
      {
        path: '/ticket/knowledge/create',
        name: 'ticketKnowledgeCreate',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/knowledgeCreate.vue'),
      },
      {
        path: '/ticket/knowledge/detail/:id',
        name: 'ticketKnowledgeDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/knowledgeDetail.vue'),
      },
      {
        path: '/ticket/knowledge/edit/:id',
        name: 'ticketKnowledgeEdit',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/ticket/child/knowledgeCreate.vue'),
      },
    ],
  },
  {
    path: '/workspace',
    name: 'workspace',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/workSpace/index.vue'),
    children: [
      {
        path: '/workspace/index',
        name: 'workspaceIndex',
        meta: {
          module_id: -1,
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/workSpace.vue'),
      },
      {
        path: '/workspace/reply',
        name: 'reply',
        meta: {
          module_id: 'materialReply',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/reply.vue'),
      },
      {
        path: '/workspace/autoReply',
        name: 'autoReply',
        meta: {
          module_id: 'autoReply',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/autoReply.vue'),
      },
      {
        path: '/workspace/autoReplyDetail/:ID/:TYPE',
        name: 'autoReplyDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/autoReplyDetail.vue'),
      },
      {
        path: '/workspace/groupWelcomeSpeech',
        name: 'groupWelcomeSpeech',
        meta: {
          module_id: 'groupWelcomeSpeech',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/groupWelcomeSpeech.vue'),
      },
      {
        path: '/workspace/groupWelcomeSpeechDetail/:ID/:TYPE',
        name: 'groupWelcomeSpeechDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/groupWelcomeSpeechDetail.vue'),
      },
      {
        path: '/workspace/newUserManage',
        name: 'newUserManage',
        meta: {
          module_id: 'newUserManage',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/sopManage/sopManage.vue'),
      },
      {
        path: '/workspace/newUserManageDetail/:TYPE',
        name: 'newUserManageDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/sopManage/microSOPManageDetail.vue'),
      },
      {
        path: '/workspace/microSOPManageDetail',
        name: 'microSOPManageDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/sopManage/microSOPManageDetail.vue'),
      },
      {
        path: '/workspace/userTag',
        name: 'userTag',
        meta: {
          module_id: 'userTag',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/internalLabelManage.vue'),
      },
      {
        path: '/workspace/microTag',
        name: 'microTag',
        meta: {
          module_id: 'microTag',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/microTag.vue'),
      },
      {
        path: '/workspace/consultTypeTag',
        name: 'consultTypeTag',
        meta: {
          module_id: 'consultTypeTag',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/consultTypeTag.vue'),
      },
      {
        path: '/workspace/moment',
        name: 'moment',
        meta: {
          module_id: 'moment',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/moment/moment.vue'),
      },
      {
        path: '/workspace/momentDetail',
        name: 'momentDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/moment/momentDetail.vue'),
      },
      {
        path: '/workspace/momentView',
        name: 'momentView',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/moment/momentView.vue'),
      },
      {
        path: '/workspace/teamApplets',
        name: 'teamApplets',
        meta: {
          module_id: 'teamApplets',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/teamApplets.vue'),
      },
      {
        path: '/workspace/evaluate',
        name: 'evaluate',
        meta: {
          module_id: 'evaluate',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/evaluate.vue'),
      },
      {
        path: '/workspace/radarLinkManage',
        name: 'radarLinkManage',
        meta: {
          module_id: 'radarLinkManage',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/radarLinkManage.vue'),
      },
      {
        path: '/workspace/favorites',
        name: 'favorites',
        meta: {
          module_id: 'favorites',
          keepAlive: true,
        },
        component: () => import('@/views/favorites/index.vue'),
      },
      {
        path: '/workspace/sensitiveWords',
        name: 'sensitiveWords',
        meta: {
          module_id: 'sensitiveWords',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/sensitiveWords.vue'),
      },
      {
        path: '/workspace/leaveComments',
        name: 'leaveComments',
        meta: {
          module_id: 'leaveComments',
          keepAlive: true,
        },
        component: () => import('@/views/leaveComments/index.vue'),
      },

      {
        path: '/workspace/orderData',
        name: 'orderData',
        meta: {
          module_id: 'orderData',
          keepAlive: true,
        },
        component: () => import('@/views/dataStatistics/child/orderData.vue'),
      },
      {
        path: '/workspace/consultStatement',
        name: 'consultStatement',
        meta: {
          module_id: 'consultStatement',
          keepAlive: true,
        },
        component: () => import('@/views/dataStatistics/child/consultStatement.vue'),
      },
      {
        path: '/workspace/realtimeAttendance',
        name: 'realtimeAttendance',
        meta: {
          module_id: 'realtimeAttendance',
          keepAlive: true,
        },
        component: () => import('@/views/dataStatistics/child/realtimeAttendance.vue'),
      },
      {
        path: '/workspace/historyAttendance',
        name: 'historyAttendance',
        meta: {
          module_id: 'historyAttendance',
          keepAlive: true,
        },
        component: () => import('@/views/dataStatistics/child/historyAttendance.vue'),
      },
      {
        path: '/workspace/receptionOverview',
        name: 'receptionOverview',
        meta: {
          module_id: 'receptionOverview',
          keepAlive: true,
        },
        component: () => import('@/views/dataStatistics/child/receptionOverview.vue'),
      },
      {
        path: '/workspace/liveCodeData',
        name: 'liveCodeData',
        meta: {
          module_id: 'liveCodeData',
          keepAlive: true,
        },
        component: () => import('@/views/dataStatistics/child/liveCodeData.vue'),
      },

      {
        path: '/workspace/channelLiveCode',
        name: 'channelLiveCode',
        meta: {
          module_id: 'channelLiveCode',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/channelLiveCode.vue'),
      },
      {
        path: '/workspace/channelLiveCodeDetail',
        name: 'channelLiveCodeDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/channelLiveCodeDetail.vue'),
      },
      {
        path: '/workspace/liveCodeOperationconfig',
        name: 'liveCodeOperationconfig',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/liveCodeOperationConfig.vue'),
      },
      {
        path: '/workspace/channelLiveCodeDetailBatch',
        name: 'channelLiveCodeDetailBatch',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/channelLiveCodeDetailBatch.vue'),
      },
      {
        path: '/workspace/sceneLiveCode',
        name: 'sceneLiveCode',
        meta: {
          module_id: 'sceneLiveCode',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/sceneLiveCode.vue'),
      },
      {
        path: '/workspace/sceneLiveCodeDetail',
        name: 'sceneLiveCodeDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/sceneLiveCodeDetail.vue'),
      },
      {
        path: '/workspace/sceneLiveCodeDetailBatch',
        name: 'sceneLiveCodeDetailBatch',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/sceneLiveCodeDetailBatch.vue'),
      },
      {
        path: '/workspace/speechSynthesis',
        name: 'speechSynthesis',
        meta: {
          module_id: 'speechSynthesis',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/speechSynthesis.vue'),
      },
      {
        path: '/workspace/speechSynthesisDetail',
        name: 'speechSynthesisDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/speechSynthesisDetail.vue'),
      },
      {
        path: '/workspace/customerQcquisition',
        name: 'customerQcquisition',
        meta: {
          module_id: 'customerQcquisition',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/customerQcquisition.vue'),
      },
      {
        path: '/workspace/customerQcquisitionDetail',
        name: 'customerQcquisitionDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/customerQcquisitionDetail.vue'),
      },
      {
        path: '/workspace/userAttribute',
        name: 'userAttribute',
        meta: {
          module_id: 'userAttribute',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/userAttribute.vue'),
      },
      {
        path: '/workspace/userAttributeDetail',
        name: 'userAttributeDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/userAttributeDetail.vue'),
      },
      {
        path: '/workspace/ruleTagGroup',
        name: 'ruleTagGroup',
        meta: {
          module_id: 'ruleTagGroup',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/ruleGroup/ruleGroup.vue'),
      },
      {
        path: '/workspace/ruleTagGroupDetail',
        name: 'ruleTagGroupDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/ruleGroup/ruleTagGroupDetail.vue'),
      },
      {
        path: '/workspace/ruleAssignGroupDetail',
        name: 'ruleAssignGroupDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/ruleGroup/ruleAssignGroupDetail.vue'),
      },
      {
        path: '/workspace/batchAddFriend',
        name: 'batchAddFriend',
        meta: {
          module_id: 'bantchAddFriend',
          keepAlive: true,
        },
        component: () => import('@/views/material/child/batchAddFriend.vue'),
      },
      {
        path: '/workspace/batchAddFriendDetail',
        name: 'batchAddFriendDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/material/child/batchAddFriendDetail.vue'),
      },
      {
        path: '/workspace/phoneSeaspool',
        name: 'phoneSeaspool',
        meta: {
          module_id: 'seaspool',
          keepAlive: true,
        },
        component: () => import('@/views/seaspool/child/PhoneSeaspool.vue'),
      },
      {
        path: '/workspace/incumbentsTransfer',
        name: 'incumbentsTransfer',
        meta: {
          module_id: 'incumbentsTransfer',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/incumbentsTransfer.vue'),
      },
      {
        path: '/workspace/incumbentsTransferDetail',
        name: 'incumbentsTransferDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/incumbentsTransferDetail.vue'),
      },
      {
        path: '/workspace/incumbentsTransferResult',
        name: 'incumbentsTransferResult',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/incumbentsTransferResult.vue'),
      },
      {
        path: '/workspace/intelligentPush',
        name: 'intelligentPush',
        meta: {
          module_id: 'intelligentPush',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/intelligentPush.vue'),
      },
      {
        path: '/workspace/intelligentPushDetail',
        name: 'intelligentPushDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/intelligentPushDetail.vue'),
      },
      {
        path: '/workspace/intelligentPushResult',
        name: 'intelligentPushResult',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/intelligentPushResult.vue'),
      },
      {
        path: '/workspace/faqSettings',
        name: 'faqSettings',
        meta: {
          module_id: -1,
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/faqSettings/faqSettings.vue'),
      },
      {
        path: '/workspace/appWelcomeSpeech',
        name: 'appWelcomeSpeech',
        meta: {
          module_id: 'appWelcomeSpeech',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/appWelcomeSpeech.vue'),
      },
      {
        path: '/workspace/appWelcomeSpeechDetail',
        name: 'appWelcomeSpeechDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/appWelcomeSpeechDetail.vue'),
      },
      {
        path: '/workspace/trafficPool',
        name: 'trafficPool',
        meta: {
          module_id: 'trafficPool',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/trafficPool/trafficPool.vue'),
      },
      {
        path: '/workspace/trafficPoolDetail',
        name: 'trafficPoolDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/trafficPool/trafficPoolDetail.vue'),
      },
      {
        path: '/workspace/advancedGroupSend',
        name: 'advancedGroupSend',
        meta: {
          module_id: 'advancedGroupSend',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/groupSendManage.vue'),
      },
      {
        path: '/workspace/advancedGroupSendDetail',
        name: 'advancedGroupSendDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/advancedGroupSendDetail.vue'),
      },
      {
        path: '/workspace/advancedGroupSendResult',
        name: 'advancedGroupSendResult',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/advancedGroupSendResult.vue'),
      },
      {
        path: '/workspace/groupAdvancedGroupSendDetail',
        name: 'groupAdvancedGroupSendDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/groupAdvancedGroupSendDetail.vue'),
      },
      {
        path: '/workspace/groupFastGroupSendDetail',
        name: 'groupFastGroupSendDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/groupFastGroupSendDetail.vue'),
      },
      {
        path: '/workspace/microStatistics',
        name: 'microStatistics',
        meta: {
          module_id: 'microStatistics',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/microStatistics.vue'),
      },
      {
        path: '/workspace/appStatistics',
        name: 'appStatistics',
        meta: {
          module_id: 'appStatistics',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/appStatistics/appStatistics.vue'),
      },
      {
        path: '/workspace/wechatCustomerStatistics',
        name: 'wechatCustomerStatistics',
        meta: {
          module_id: 'wechatCustomerStatistics',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/wechatCustomerStatistics/wechatCustomerStatistics.vue'),
      },
      {
        path: '/workspace/fastGroupSendMission',
        name: 'fastGroupSendMission',
        meta: {
          module_id: -1,
          keepAlive: false,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/fastGroupSendMission.vue'),
      },
      {
        path: '/workspace/fastGroupSendResult',
        name: 'fastGroupSendResult',
        meta: {
          module_id: -1,
          keepAlive: false,
        },
        component: () => import('@/views/workSpace/child/groupSendManage/fastGroupSendResult.vue'),
      },
      {
        path: '/workspace/microWelcomeSpeech',
        name: 'microWelcomeSpeech',
        meta: {
          module_id: 'microWelcomeSpeech',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/microWelcomeSpeech.vue'),
      },
      {
        path: '/workspace/microWelcomeSpeechDetail',
        name: 'microWelcomeSpeechDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/microWelcomeSpeechDetail.vue'),
      },

      {
        path: '/workspace/microWelcomeSpeechView',
        name: 'microWelcomeSpeechView',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/microWelcomeSpeechView.vue'),
      },
      {
        path: '/workspace/automaticLabeling',
        name: 'automaticLabeling',
        meta: {
          module_id: 'automaticLabeling',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/automaticLabeling.vue'),
      },
      {
        path: '/workspace/automaticLabelingDetail',
        name: 'automaticLabelingDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/automaticLabelingDetail.vue'),
      },
      {
        path: '/workspace/modelManage',
        name: 'modelManage',
        meta: {
          keepAlive: true,
          module_id: 'modelManage',
        },
        component: () => import('@/views/workSpace/child/modelManage.vue'),
      },
      {
        path: '/workspace/appManage',
        name: 'appManage',
        meta: {
          keepAlive: true,
          module_id: 'appManage',
        },
        component: () => import('@/views/workSpace/child/appManage.vue'),
      },
      {
        path: '/workspace/wechatCSManage',
        name: 'wechatCSManage',
        meta: {
          keepAlive: true,
          module_id: 'wechatCSManage',
        },
        component: () => import('@/views/workSpace/child/wechatCSManage/wechatCSManage.vue'),
      },
      {
        path: '/workspace/wechatCSAccountManage',
        name: 'wechatCSAccountManage',
        meta: {
          keepAlive: false,
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/wechatCSManage/wechatCSAccountManage.vue'),
      },
      {
        path: '/workspace/memberGroupManage',
        name: 'memberGroupManage',
        meta: {
          keepAlive: true,
          module_id: 'memberGroupManage',
        },
        component: () => import('@/views/workSpace/child/memberGroupManage/memberGroupManage.vue'),
      },
      {
        path: '/workspace/robotManage',
        name: 'robotManage',
        meta: {
          keepAlive: true,
          module_id: 'baseConfig',
        },
        component: () => import('@/views/workSpace/child/robotManage.vue'),
      },
      {
        path: '/workspace/unilateralCustomerManage',
        name: 'unilateralCustomerManage',
        meta: {
          keepAlive: true,
          module_id: 'unilateralCustomerManage',
        },
        component: () => import('@/views/workSpace/child/unilateralCustomerManage/unilateralCustomerManage.vue'),
      },
      {
        path: '/workspace/taskManage',
        name: 'taskManage',
        meta: {
          keepAlive: true,
          module_id: 'taskManage',
        },
        component: () => import('@/views/workSpace/child/taskManage/taskManage.vue'),
      },
      {
        path: '/workspace/notificationConfiguration',
        name: 'notificationConfiguration',
        meta: {
          keepAlive: true,
          module_id: 'notificationConfiguration',
        },
        component: () => import('@/views/workSpace/child/notificationConfiguration/notificationConfiguration.vue'),
      },
      {
        path: '/workspace/microToolbarSetting',
        name: 'microToolbarSetting',
        meta: {
          keepAlive: true,
          module_id: 'microToolbarSetting',
        },
        component: () => import('@/views/workSpace/child/microToolbarSetting.vue'),
      },
      {
        path: '/workspace/scheduleManage',
        name: 'scheduleManage',
        meta: {
          keepAlive: true,
          module_id: 'scheduleManage',
        },
        component: () => import('@/views/workSpace/child/scheduleManage/scheduleManage.vue'),
      },
      {
        path: '/workspace/customerSeaspool',
        name: 'customerSeaspool',
        meta: {
          keepAlive: true,
          module_id: 'customerSeaspool',
        },
        component: () => import('@/views/workSpace/child/customerSeaspool/customerSeaspool.vue'),
      },
      {
        path: '/workspace/filterWords',
        name: 'filterWords',
        meta: {
          keepAlive: true,
          module_id: 'filterWords',
        },
        component: () => import('@/views/workSpace/child/filterWords/filterWords.vue'),
      },
      {
        path: '/workspace/socialStatistics',
        name: 'socialStatistics',
        meta: {
          module_id: 'socialStatistics',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/socialStatistics/socialStatistics.vue'),
      },
      {
        path: '/workspace/serviceConfiguration',
        name: 'serviceConfiguration',
        meta: {
          module_id: 'serviceConfiguration',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/serviceConfiguration/serviceConfiguration.vue'),
      },
      {
        path: '/workspace/customerManage',
        name: 'customerManage',
        meta: {
          module_id: 'customerManage',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/customerManage/customerManage.vue'),
      },
      {
        path: '/workspace/robotSpeechConfiguration',
        name: 'robotSpeechConfiguration',
        meta: {
          module_id: 'robotSpeechConfiguration',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/robotSpeechConfiguration/robotSpeechConfiguration.vue'),
      },
      {
        path: '/workspace/robotSpeechConfigurationDetail',
        name: 'robotSpeechConfigurationDetail',
        meta: {
          module_id: -1,
          keepAlive: false,
        },
        component: () => import('@/views/workSpace/child/robotSpeechConfiguration/robotSpeechConfigurationDetail.vue'),
      },
      {
        path: '/workspace/paymentSetting',
        name: 'paymentSetting',
        meta: {
          module_id: 'paymentSetting',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/paymentSetting/paymentSetting.vue'),
      },
      {
        path: '/workspace/contactCode',
        name: 'contactCode',
        meta: {
          module_id: 'contactCode',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/contactCode/contactCode.vue'),
      },
      {
        path: '/workspace/externalGroupManage',
        name: 'externalGroupManage',
        meta: {
          module_id: 'externalGroupManage',
          keeepAlive: true,
        },
        component: () => import('@/views/workSpace/child/externalGroupManage/externalGroupManage.vue'),
      },
      {
        path: '/workspace/externalGroupManageDetail',
        name: 'externalGroupManageDetail',
        meta: {
          module_id: -1,
          keeepAlive: true,
        },
        component: () => import('@/views/workSpace/child/externalGroupManage/comp/ExternalGroupDetail.vue'),
      },
      {
        path: '/workspace/personalDashboard',
        name: 'personalDashboard',
        meta: {
          module_id: -1,
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/personalDashboard/personalDashboard.vue'),
      },
      {
        path: '/workspace/personalDashboardDetail',
        name: 'personalDashboardDetail',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/workSpace/child/personalDashboard/personalDashboardDetail.vue'),
      },
      {
        path: '/workspace/secondLineMiniProgram',
        name: 'secondLineMiniProgram',
        meta: {
          module_id: 'secondLineMiniProgram',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/secondLineMiniProgram/secondLineMiniProgram.vue'),
      },
      {
        path: '/workspace/enterpriseWechatManage',
        name: 'enterpriseWechatManage',
        meta: {
          module_id: 'enterpriseWechatManage',
          KeepAlive: true,
        },
        component: () => import('@/views/workSpace/child/enterpriseWechatManage/index.vue'),
      },
      {
        path: '/workspace/orderAssistant',
        name: 'orderAssistant',
        meta: {
          module_id: 'orderAssistant',
          KeepAlive: true,
        },
        component: () => import('@/views/workSpace/child/orderAssistant.vue'),
      },
      {
        path: '/workspace/virtualRobotManage',
        name: 'virtualRobotManage',
        meta: {
          keepAlive: true,
          module_id: 'virtualRobotManage',
        },
        component: () => import('@/views/workSpace/child/virtualRobotManage.vue'),
      },
      {
        path: '/workspace/commentStatistics',
        name: 'commentStatistics',
        meta: {
          module_id: 'commentStatistics',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/commentStatistics.vue'),
      },
      {
        path: '/workspace/citySummary',
        name: 'citySummary',
        meta: {
          module_id: 'citySummary',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/citySummary.vue'),
      },
      {
        path: '/workspace/userIpSummary',
        name: 'userIpSummary',
        meta: {
          module_id: 'userIpSummary',
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/userIpSummary.vue'),
      },
      {
        path: '/workspace/downloadCenter',
        name: 'downloadCenter',
        meta: {
          module_id: -1,
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/downloadCenter/downloadCenter.vue'),
      },
      {
        path: '/workspace/downloadCenterDetail',
        name: 'downloadCenterDetail',
        meta: {
          module_id: -1,
          keepAlive: true,
        },
        component: () => import('@/views/workSpace/child/downloadCenter/downloadCenterDetail.vue'),
      },
    ],
  },
  // 移动端路由
  {
    path: '/mHome',
    name: 'mHome',
    meta: {
      keep_alive: false,
      module_id: -1,
    },
    component: () => import('@/views/mobile/home/index.vue'),
    children: [
      {
        path: '/mHome/chatReception',
        name: 'chatReception',
        meta: {
          module_id: 'chat',
        },
        component: () => import('@/views/mobile/home/child/chatReception.vue'),
      },
      {
        path: '/mHome/historyMessage',
        name: 'historyMessage',
        meta: {
          keep_alive: false,
          module_id: 'conversation',
        },
        component: () => import('@/views/mobile/home/child/historyMessage.vue'),
      },
      {
        path: '/mHome/mine',
        name: 'mine',
        meta: {
          module_id: -1,
        },
        component: () => import('@/views/mobile/home/child/mine.vue'),
      },
    ],
  },
  {
    path: '/mChatBody',
    name: 'mChatBody',
    meta: {
      keep_alive: false,
      module_id: 'chat',
    },
    component: () => import('@/views/mobile/chat/chatBody.vue'),
  },
  {
    path: '/mTransfer',
    name: 'mTransfer',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/mobile/chat/transfer.vue'),
  },
];
